import { cacheDom } from '../utils/QuerySelectors.js'
import { toggleModal } from '../components/Popup.js'
import { getProductsByIds } from '../utils/Product.js'
import { GTM_plpViewItems } from '../utils/Gtm.js'

const dom = {}
const qs = {
  header: 'data-section-type="header"',
  mobileTrigger: 'data-mobile-menu-trigger',
  searchPanel: 'data-search-panel',
  searchPanelInner: 'data-search-panel-inner',
  searchClose: 'data-search-close',
  searchInput: 'data-search-input',
  searchResults: 'data-predictive-search',
  searchRecommend: 'data-search-recommend',
  // cartTrigger: 'data-cart-trigger',
  cartCount: 'data-cart-count',
  cartPanel: 'data-mini-cart-panel',
  cartPanelInner: 'data-mini-cart-panel-inner',
  cartClose: 'data-mini-cart-close',
  searchTriggerMobile: 'data-search-mobile',
  searchInputMobile: 'predictive-search-input',
  announcementBar: 'data-announcement-bar',
  announcementSwiper: 'data-announcement-swiper',
  announcementClose: 'data-announcement-close',
  cartRecent: 'data-cart-recent',
  cartRecentSlider: 'data-cart-recent-swiper',
  cartLastElement: 'data-last-inlnie-cart-element',
  selectedProducts: 'data-products-grid-selected'
}
const qsAll = {
  desktopNavGroups: 'data-desktop-group',
  parentElements: 'data-desktop-parent',
  mobileParentElements: 'data-mobile-nav-parent',
  qtyChanges: 'data-qty-change',
  searchTriggers: 'data-search',
  cartTriggers: 'data-cart-trigger',
  announcementItems: 'data-announcement-item',
}

const state = {
  searchInputTimer: null,
  searchTerm: null,
}

const onSearchChange = (predictive=true, results=false) => {
  state.searchTerm = dom.searchInput.value.trim()
  if (state.searchTerm === "") {
    getSearchResults(predictive, results)
  }
  else {
    getSearchResults(predictive, true)
  }
}

const updateProductsCount = () => {
  const collections = Array.from(dom.searchResults.querySelectorAll('[data-search-plp]'))
  collections.forEach((col) => {
    const url = `${col.querySelector('a').href}${col.querySelector('a').href.includes('?') ? '&' : '?'}view=filter`
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        col.querySelector('[data-title]').innerHTML = `${data.title.toLowerCase().replace(state.searchTerm.toLowerCase(), '<span class="text-black font-bold">' + state.searchTerm + '</span>')}`
        col.querySelector('[data-count]').innerHTML = data.productsCount
      })
      .catch((error) => {
        throw error
      })
  })
}
const getSearchResults = (renderPredictive, renderResults) => {
  const wrapper = dom.searchLoader
  const currentTerm = state.searchTerm.trim()

  Shopify.analytics.publish('gtm_view_search_results', {
    search_term: currentTerm,
  })

  // if empty input
  if (currentTerm === '') {
    const quicknav = dom.searchResults.querySelector('.search-results--quicknav')
    if (quicknav) quicknav.remove()

    const collections = dom.searchResults.querySelector('.search-result-collections')
    if (collections) {
      dom.searchResults.innerHTML = collections.outerHTML
    } else {
      dom.searchResults.innerHTML = ''
    }

    wrapper.classList.remove('is-loading')
    return
  }

  // if full input
  wrapper.classList.add('is-loading')

  // FETCH PREDICTIVE
  const predictiveFetch = renderPredictive
    ? fetch(`/search/suggest.json?q=${currentTerm}&resources[type]=collection&resources[limit]=5`)
        .then((response) => response.json())
        .then((data) => {
          if (state.searchTerm.trim() !== currentTerm) return

          if (data.resources.results.collections.length > 0) {
            dom.searchResults.innerHTML = `<ul class="search-result-collections flex flex-col gap-4 mb-2.5">
              ${data.resources.results.collections
                .map((col) => {
                  return `<li class="flex items-center justify-between text-xs leading-4" data-search-plp="${window.Shopify.routes.root}collections/${col.handle}">
                    <a class="uppercase text-fifth-grey text-xs leading-4" href="${Shopify.routes.root}collections/${col.handle}" data-title>
                      ${col.title
                        .toLowerCase()
                        .replace(currentTerm.toLowerCase(), '<span class="text-black">' + currentTerm + '</span>')}
                    </a>
                    <span data-count></span>
                  </li>`
                })
                .join('')}
            </ul>`
          } else if (dom.searchResults.querySelector('.search-result-collections')) {
            dom.searchResults.querySelector('.search-result-collections').remove()
          }
          dom.searchRecommend.classList.add('hidden')
        })
    : Promise.resolve()

  // FETCH PRODUCTS
  const filterTags = dom.searchResults.querySelector('.search-collection-tag--active[data-tag="all"]') ? '' : Array.from(dom.searchResults.querySelectorAll('.search-collection-tag--active')).map((btn) => `filter.p.tag=${encodeURIComponent(btn.dataset.tag)}`).join('&')

  const resultsFetch = fetch(
    `${window.Shopify.routes.root}search?q=${encodeURIComponent(currentTerm)}&options[type]=product${
      filterTags === '' ? '' : '&' + filterTags
    }`
  )
    .then((response) => response.text())
    .then((responseText) => {
      if (state.searchTerm.trim() !== currentTerm) return
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      if (dom.searchResults.querySelector('.search-results--panel'))
        dom.searchResults.querySelector('.search-results--panel').remove()
      dom.searchResults.innerHTML +=
        `<div class="search-results--panel ${renderResults ? '' : '!hidden'}">` +
        html.querySelector('[data-inline-results]').innerHTML +
        `<ul class="search-results--grid grid grid-cols-2 lg:grid-cols-3 gap-x-2.5 gap-y-6">${html.querySelector('.product-grid') ? html.querySelector('.product-grid').innerHTML : ''}</ul></div>`

      if(renderResults){
        GTM_plpViewItems(document.querySelectorAll('#predictive-search .search-results--grid [data-gtm-items-el]:not(.gtm-item_viewed)'));
      }

      const cards = dom.searchResults.querySelectorAll('[data-product-card]')
      if (cards.length == 1 && currentTerm.toUpperCase().includes(cards[0].getAttribute('data-sku')))
        location.href = cards[0].dataset.url
      if (dom.searchResults.querySelector('.search-results--quicknav'))
        dom.searchResults.querySelector('.search-results--quicknav').remove()
      dom.searchResults.innerHTML = html.querySelector('[data-inline-nav]').innerHTML + dom.searchResults.innerHTML
      updateProductsCount()
      const navs = dom.searchResults.querySelectorAll('[data-tag]')
      navs.forEach((nav) => {
        nav.addEventListener('click', (e) => {
          e.preventDefault()
          e.stopPropagation()
          e.target.classList.toggle('search-collection-tag--active')
          const filterTags = dom.searchResults.querySelector('.search-collection-tag--active[data-tag="all"]') ? '' : Array.from(dom.searchResults.querySelectorAll('.search-collection-tag--active')).map((btn) => `filter.p.tag=${encodeURIComponent(btn.dataset.tag)}`).join('&')
          const plps = dom.searchResults.querySelectorAll('[data-search-plp]')
          plps.forEach((plp) => {
            const plpUrl = `${plp.getAttribute('data-search-plp')}?${filterTags}`
            plp.querySelector('a').href = plpUrl
          })
          updateProductsCount()
          onSearchChange(false, true)
        })
      })
    })
  // hide loader
  Promise.all([predictiveFetch, resultsFetch]).finally(() => {
    setTimeout(() => {
      if (state.searchTerm.trim() !== currentTerm) return
      wrapper.classList.remove('is-loading')
    }, 200)
  })
}

const openCart = (open = true) => {
  setTimeout(function(){
    dom.cartPanel.classList.toggle('!block', open)
    dom.cartPanel.classList.toggle('z-[102]', open)
  }, open? 0 : 300)

  setTimeout(function(){
    document.body.classList.toggle('cart--opened', open)
    if(open) dom.cartClose.focus()
  }, 50)

  if(dom.cartTriggers.filter(trigger => trigger.dataset.inited).length == 0) {
    dom.cartTriggers.forEach(trigger => trigger.setAttribute('data-inited', 'true'))
    window.getCart((cart) => {
      initMiniCart(cart, true)
    })
  }
}
window.openCart = openCart

const updateRecentProducts = () => {
  if (typeof Cookies.get('recently_viewed_ids') != 'undefined' && Cookies.get('recently_viewed_ids')) {
    const ids = Cookies.get('recently_viewed_ids')
      .split(',')
      .reverse()
      .map((id) => `"gid://shopify/Product/${id}"`)
    const cartRecentSlider = document.querySelector(`[${qs.cartRecentSlider}]`)
    const innerSlider = cartRecentSlider?.querySelector('.swiper-wrapper')
    if (innerSlider) {
      getProductsByIds((products) => {
        products.forEach((product) => {
          if (product.handle) {
            innerSlider.innerHTML += `
              <a class="swiper-slide flex flex-col gap-1.5" href="/products/${product.handle}" target="_blank">
                <img class="w-full h-auto mb-2.5" src="${product.featuredImage.url}&width=160" alt="${product.title} - Image" />
                <div>${product.title}</div>
              </a>
            `
          }
        })
        new Swiper(cartRecentSlider, {
          slidesPerView: 3.5,
          spaceBetween: 10,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        })
        document.querySelector(`[${qs.cartRecent}]`).classList.remove('hidden')
      }, ids)
    }
  }
}
window.updateRecentProducts = updateRecentProducts

const initMiniCart = (cart, initUpsells = true) => {
  const qtyChanges = dom.cartPanel.querySelectorAll(`[${qsAll.qtyChanges}]`)
  qtyChanges.forEach((qtyChange) => {
    qtyChange.addEventListener('click', () => {
      window.changeLineItem(
        (cart) => {
          initMiniCart(cart)
        },
        {
          quantity: parseInt(qtyChange.dataset.quantity),
          id: qtyChange.dataset.itemKey,
        },
        {
          type: 'remove_from_cart',
          cart: cart,
          prevQuantity: qtyChange.dataset.prevQuantity,
        }
      )
    })
  })
}
window.initMiniCart = initMiniCart

const openSearch = (open = true) => {
  setTimeout(function(){
    dom.searchPanel.classList.toggle('!block', open)
    dom.searchPanel.classList.toggle('z-50', open)
    dom.searchPanel.classList.toggle('opacity-0', !open)
    dom.searchPanel.classList.toggle('opacity-100', open)
    dom.searchPanel.classList.toggle('-z-1', !open)
  }, open? 0 : 300);
  setTimeout(function(){
    dom.searchPanel.classList.toggle('opened', open)
    if (open) dom.searchInput.focus()
  }, 50)
}

const scrollEvent = () => {
  const offSet = document.querySelector('.plp-banner') ? document.querySelector('.plp-banner').offsetHeight + 60 : 80
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  if (scrollTop > offSet) {
    dom.stickyHeader.classList.add('header-sticky')
    document.body.classList.add('body-scrolled')
  } else {
    dom.stickyHeader.classList.remove('header-sticky')
    document.body.classList.remove('body-scrolled')
  }
}

export const setupHeader = () => {
  cacheDom(dom, qs, qsAll)
  dom.stickyHeader = document.querySelector('#shopify-section-header')
  window.addEventListener('scroll', scrollEvent)

  let loader = dom.searchInput.parentElement.querySelector('.search-loader-wrapper')
  if (!loader) {
    loader = document.createElement('div')
    loader.className = 'search-loader-wrapper'
    dom.searchInput.parentElement.appendChild(loader)
  }
  dom.searchLoader = loader

  // Desktop
  new SV.HoverIntent(dom.desktopNavGroups, {
    onEnter: function (navGroup) {
      navGroup.classList.add('header-desktop--topitem__active')
      let menu = navGroup.querySelector('.header-desktop--panel')
      if (menu) menu.style.maxHeight = menu.scrollHeight + "px";
    },
    onExit: function (navGroup) {
      navGroup.classList.remove('header-desktop--topitem__active')
      let menu = navGroup.querySelector('.header-desktop--panel')
      if (menu) menu.style.maxHeight = "0px";
    },
    exitDelay: 400,
    interval: 100,
    sensitivity: 7,
  })
  dom.parentElements.forEach(parentElement => {
    parentElement.addEventListener('focus', () => {
      const navGroup = parentElement.closest('[data-desktop-group]')
      navGroup?.dispatchEvent(new Event('mouseenter'))
      setTimeout(() => {
        if(navGroup && !navGroup.classList.contains('header-desktop--topitem__active')) {
          navGroup.classList.add('header-desktop--topitem__active')
          let menu = navGroup.querySelector('.header-desktop--panel')
          if (menu) menu.style.maxHeight = menu.scrollHeight + "px"

          dom.desktopNavGroups.forEach(nav => {
            if(nav != navGroup) {
              nav.classList.remove('header-desktop--topitem__active')
              let menu = navGroup.querySelector('.header-desktop--panel')
              if (menu) menu.style.maxHeight = '';
            }
          })
        }
      }, 50)
    })
  })

  const lastMenuGroup = dom.desktopNavGroups[dom.desktopNavGroups.length - 1]
  const lastAElements = lastMenuGroup?.querySelectorAll('.header-desktop--panel a')
  const lastMenuElement = lastAElements[lastAElements.length - 1]
  lastMenuElement?.addEventListener('focusout', (e) => {
    lastMenuGroup.classList.remove('header-desktop--topitem__active')
    let menu = lastMenuGroup.querySelector('.header-desktop--panel')
    if (menu) menu.style.maxHeight = ''
  })

  if (window.privateSale) {
    const saleNav = document.querySelector('[data-desktop-group="sale"]')
    if (saleNav) saleNav.classList.remove('!hidden')
  }
  if(window.privateSaleEnabled) {
    dom.desktopNavGroups.forEach((navGroup) => {
      if(navGroup.classList.contains('!hidden') && window.privateSale && window.showForLoggedInUsers) {
        navGroup.classList.remove('!hidden')
      }
    })
    dom.mobileParentElements.forEach(element => {
      if(element.classList.contains('!hidden') && window.privateSale && window.showForLoggedInUsers) {
        element.classList.remove('!hidden')
      }
    })
  }


  // Mobile Menu

  const mobileNavMain = document.body.querySelector('.header-mobile--links')

  dom.mobileTrigger.addEventListener('click', () => {
    if (dom.header.hasAttribute('open')) {
      document.body.classList.remove('overflow-hidden', 'mobile-nav--opened')
      dom.header.removeAttribute('open')
      mobileNavMain.classList.remove('header-mobile--inlev1', 'header-mobile--inlev2')
      setTimeout(function(){
        document.body.querySelectorAll('.header-mobile--navgroup').forEach((group) => {
          group.classList.remove('active')
        })
      }, 300)
    } else {
      dom.header.setAttribute('open', '')
      document.body.classList.add('overflow-hidden', 'mobile-nav--opened')
    }
  })

  const mobileNavLinks = Array.from(document.querySelectorAll('[data-mobilenavlink]'))

  mobileNavLinks.forEach((navlink) => {
    navlink.addEventListener('click', (e) => {
      e.stopPropagation()
      document.body.querySelector('.header-mobile--navgroup[data-mobilenavid="'+navlink.dataset.mobilenavlink+'"]').classList.add('active')
      if (mobileNavMain.classList.contains('header-mobile--inlev1')) {
        mobileNavMain.classList.remove('header-mobile--inlev1')
        mobileNavMain.classList.add('header-mobile--inlev2')
      } else {
        mobileNavMain.classList.add('header-mobile--inlev1')
      }
    })
  })

  const navLevelUp = (navlink) => {
    navlink.addEventListener('click', (e) => {
      e.stopPropagation()
      if (mobileNavMain.classList.contains('header-mobile--inlev2')) {
        mobileNavMain.classList.remove('header-mobile--inlev2')
        mobileNavMain.classList.add('header-mobile--inlev1')
      } else {
        mobileNavMain.classList.remove('header-mobile--inlev1')
      }
      setTimeout(function(){
        navlink.closest('.header-mobile--navgroup').classList.remove('active')
      }, 300)
    })
  }

  const navBackToRoot = (navlink) => {
    navlink.addEventListener('click', (e) => {
      e.stopPropagation()
      mobileNavMain.classList.remove('header-mobile--inlev1', 'header-mobile--inlev2')
      setTimeout(function(){
        document.body.querySelectorAll('.header-mobile--navgroup').forEach((group) => {
          group.classList.remove('active')
        })
      }, 300)
    })
  }

  Array.from(document.querySelectorAll('.header-mobile--navgroup-lev1 .header-mobile-breadcrumbs > div')).forEach(navLevelUp)
  Array.from(document.querySelectorAll('.header-mobile--navgroup-lev2 .header-mobile-breadcrumbs > div:first-child')).forEach(navBackToRoot)
  Array.from(document.querySelectorAll('.header-mobile--navgroup-lev2 .header-mobile-breadcrumbs > div:last-child')).forEach(navLevelUp)

  // Inline Search
  dom.searchTriggers.forEach((searchTrigger) => {
    searchTrigger.addEventListener('click', () => {
      openSearch()
    })
  })
  dom.searchTriggerMobile.addEventListener('click', () => {
    dom.header.setAttribute('open', '')
    document.body.classList.add('overflow-hidden', 'mobile-nav--opened')
    setTimeout(() => {
      dom.searchInputMobile.focus()
    }, 100)
  })
  dom.searchClose.addEventListener('click', (e) => {
    e.stopPropagation()
    e.preventDefault()
    openSearch(false)
  })
  dom.searchPanel.addEventListener('click', (e) => {
    openSearch(false)
  })
  dom.searchPanelInner.addEventListener('click', (e) => {
    e.stopPropagation()
  })
  dom.searchInput.addEventListener('input', () => {
    clearTimeout(state.searchInputTimer)
    state.searchInputTimer = setTimeout(() => {
      onSearchChange()
    }, 300)
  })
  dom.searchInput.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      const productsList = dom.searchResults.querySelector('.search-results--panel');
      if (productsList) {
        const target = productsList.querySelector(`[${qs.selectedProducts}]`);
        if (target) target.click();
      }
    }
  })
  // Trapping focus on the search modal
  dom.searchPanelInner.addEventListener("transitionend", e => {
    dom.searchPanelInner.querySelector('[type="search"]').focus()
  })

  // Mini Bag
  dom.header.addEventListener('mouseover', () => {
    if(dom.cartTriggers.filter(trigger => trigger.dataset.inited).length == 0) {
      dom.cartTriggers.forEach(trigger => trigger.setAttribute('data-inited', 'true'))
      window.getCart((cart) => {
        initMiniCart(cart, true)
      })
    }
  })
  dom.cartClose.addEventListener('click', () => {
    openCart(false)
  })

  dom.cartTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.stopPropagation()
      openCart(!dom.cartPanel.classList.contains('!block'))
    })
  })
  dom.cartPanelInner.addEventListener('click', (e) => {
    e.stopPropagation()
  })
  dom.cartPanel.addEventListener('click', (e) => {
    openCart(false)
  })
  window.addEventListener('click', () => {
    openCart(false)
  })
  window.addEventListener('keyup', (e) => {
    if(e.key === "Escape") {
      openCart(false)
      openSearch(false)
    }
  })

  // Announcement Bar
  if (dom.announcementSwiper) {
    const seconds = parseInt(dom.announcementSwiper.dataset.seconds)
    new Swiper(dom.announcementSwiper, {
      autoplay:
        seconds > 0 && dom.announcementItems.length > 0
          ? {
              delay: seconds * 1000,
            }
          : false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      // effect: 'fade',
      // fadeEffect: {
      //   crossFade: true,
      // },
    })
    const pageBtns = dom.announcementSwiper.querySelectorAll('[href="#announcement"]')
    pageBtns.forEach((pageBtn) => {
      pageBtn.addEventListener('click', (e) => {
        const slide = pageBtn.closest('.swiper-slide')
        const pageUrl = slide.dataset.page
        if (pageUrl && pageUrl != '') {
          e.stopPropagation()
          e.preventDefault()
          fetch(pageUrl)
            .then((res) => res.text())
            .then((res) => {
              const element = new DOMParser().parseFromString(res, 'text/html')
              const innerHTML = `<div class="page-pop-content p-2.5 lg:p-12">${element.querySelector('.custom-liquid > .container') ? element.querySelector('.custom-liquid > .container').innerHTML : element.getElementById('MainContent').innerHTML}</div>`
              toggleModal(true, innerHTML)
            })
        }
      })
    })
    dom.announcementClose.addEventListener('click', () => {
      dom.announcementBar.remove()
      document.body.classList.remove('has-announcement')
      Cookies.set('announcement-closed', true)
    })

    if(typeof Cookies.get('announcement-closed') != 'undefined') {
      dom.announcementClose.dispatchEvent(new Event('click'))
    } else {
      dom.announcementBar.classList.add('!flex')
    }
  }
}
